import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Container,Image} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import queryString from "qs"

@observer
export default class CartTotalMinimum extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0,
            showCalc:   false,
		}
	}
    componentDidMount() {
    }


	render() {
		let { loading} = shop.cart
        let { sum, deliveraddress } = shop.cart.data
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
        const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (Number(sum) > shop.config.MIN_ORDER_VALUE)
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (Number(sum) > shop.config.MIN_ORDER_FREE_VALUE)
		let shippingCosts = sum <= 100 ? "9,95" : (sum >= 150 ? "0,00" : "7,95");
        console.log("shop.cart.data.deliveraddress",shop.cart.data.deliveraddress, "TEST ", deliveraddress)
        if(shop.session && shop.session.shopuser){
            aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
            (Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || 
            (shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && 
             (shop.cart.data.deliveraddress.extras.lieferart == "EL" || 
              shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
            (shop.cart.data.deliveraddress && Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && 
             (shop.session.value.extras.lieferart == "EL" || 
              shop.session.value.extras.lieferart == "Abholung"));
        }

        //console.log("shop.config",shop.config)
        //console.log("shop.session",shop.cart.data.deliveraddress)
        //console.log("aboveMinFree",aboveMinFree, shippingCosts, sum, MIN_ORDER_FREE_VALUE)
		if ( !shop.session ) return null

        return (
            <div className="CartButton relative">
                <Button style={{width: "42px", height: "31px"}}
                    primary
                    className=""
                    onMouseEnter={() => this.setState( {showCalc: true} )}
                    onMouseLeave={() => this.setState( {showCalc: false} )}
                >
                    <Popup trigger={
                        <React.Fragment>
                            {aboveMin ? <Icon className="check mark" /> : <Icon name={"warning circle"} />}
                        </React.Fragment>
                    }>
                    </Popup>
                </Button>
                <td onMouseLeave={() => this.setState( {showCalc: false} )} style={{alignContent: "center"}}>
                    <div>
                        
                        {this.state.showCalc && <Container style={{ padding: 0 , width: "1220px", alignContent: "center", zIndex: "99"}} 
          className="absolute bg-white z-99 animate fadeIn variantsContainer" >
            <div style={{ alignContent: "center", width: "500px", zIndex: "99",marginLeft: "-458px"}}  className="justify-between bg-white pa3 VariantsPullDownCart shadow-3">
                <div className="pt2 pb3 black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price><br/></div>
                <table className="pb3">
                <colgroup>
                    <col width="85%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        {!aboveMinFree && <div className="pb2 b">{translate("Kostenloser Versand erreicht in: ")}&nbsp;</div>}
                        {!aboveMinFree && <div className="pb2 b">{translate("Lieferkosten: ")}</div>}
                        {aboveMinFree && <div className="pb2 b">{translate("Kostenloser Versand erreicht!")}</div>}
                    </td>
                    <td className="b tr">
                        {!aboveMinFree && <div className="pb2 b"><Price>{MIN_ORDER_FREE_VALUE-sum}</Price></div>}
                        {!aboveMinFree && <div className="pb2 b"><Fragment>&nbsp;{shippingCosts} &nbsp;EUR</Fragment></div>}</td>
                    </tr>
                    <tr>
                    <td>{!aboveMinFree && <MinOrderFreeValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>

                <table>
                <colgroup>
                    <col width="15%"/>
                    <col width="70%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                        </td>
                    <td>
                        {!aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht in: ")}</div>}
                        {aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht!")} </div>}
                    </td>
                    <td className="b tr">
                        {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                    </tr>
                    <tr>
                        <td></td>
                    <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>
            </div></Container>}
                    </div>
                </td>
                </div>
        );
	}
}





// WEBPACK FOOTER //
// ./src/theme/hvz/components/Cart/CartTotalMinimum.js